import { InputField, InputSelectOptions } from 'components'
import RejectItemSchema from 'domains/internal-request-ops/organisms/reject-item-form/reject-item-schema'
import { ITEM_REJECT_REASON } from 'domains/internal-request/constants'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import LoaderButton from 'components/molecules/loader-button'
import { Button } from 'reactstrap'

const propTypes = {
  internalRequestItem : PropTypes.object,
  handleSubmit        : PropTypes.func.isRequired,
  onCancelButtonClick : PropTypes.func
}

/**
 * Reject item form for processing Internal Reqeust Item Ops
 * @param {object} internalRequestItem - Internal Request Item
 * @param {func} handleSubmit - Handler to submit
 * @param {func} onCancelButtonClick - Handler for the cancel button
 */

const RejectItemFields = ({
  formikBag,
  internalRequestItem,
  onCancelButtonClick
}) => {
  const isOtherReason = formikBag.values.reject_reason === ITEM_REJECT_REASON.OTHER

  useEffect(() => {
    if (!isOtherReason && formikBag.values.reject_note) {
      formikBag.setFieldValue('reject_note', '')
    }
  }, [ isOtherReason ]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Form>
      <InputField
        name="reject_reason"
        type="select"
        label="Reject Reason"
        required={ true }
      >
        <InputSelectOptions options={ ITEM_REJECT_REASON } keyPrefix={ 'reject-reason' } />
      </InputField>

      {
        isOtherReason && (
          <InputField
            name="reject_note"
            type="textarea"
            label="Reject Note"
            placeholder="Tulis alasan reject lainnya"
            required={ true }
          />
        )
      }

      <InputField
        name='quantity'
        type='number'
        label='Rejected Quantity'
        formGroupClassName='mr-3 w-25 h-50'
        min={ 1 }
        max={ internalRequestItem.quantity }
      />

      <LoaderButton
        color='primary'
        type='submit'
        className='d-inline'
        onSubmit={ formikBag.submitForm }
        disabled={ formikBag.isSubmitting }
        isLoading={ formikBag.isSubmitting }
        text='Reject'
      />

      <Button
        color='warning'
        className='d-inline'
        onClick={ onCancelButtonClick }
      >
        Cancel
      </Button>
    </Form>
  )
}

RejectItemFields.propTypes = {
  formikBag             : PropTypes.object,
  internalRequestItem   : PropTypes.object,
  onCancelButtonClick   : PropTypes.func
}

const RejectItemForm = ({
  handleSubmit,
  internalRequestItem,
  onCancelButtonClick
}) => (
  <Formik
    initialValues={{
      reject_reason : '',
      reject_note   : '',
      quantity      : 0
    }}
    validationSchema={ RejectItemSchema(internalRequestItem) }
    onSubmit={ (values, formikBag) => handleSubmit(values, formikBag) }
  >
    {
      (formikBag) => (
        <RejectItemFields
          formikBag={ formikBag }
          internalRequestItem={ internalRequestItem }
          onCancelButtonClick={ onCancelButtonClick }
        />
      )
    }
  </Formik>
)

RejectItemForm.propTypes = propTypes

export default RejectItemForm